import { render, staticRenderFns } from "./TagMgt.vue?vue&type=template&id=3822c77b&scoped=true"
import script from "./TagMgt.vue?vue&type=script&lang=js"
export * from "./TagMgt.vue?vue&type=script&lang=js"
import style0 from "./TagMgt.vue?vue&type=style&index=0&id=3822c77b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3822c77b",
  null
  
)

export default component.exports